import getBannerById from '@services/content/getBannerById';

(function () {
  'use srict';

  const elements = document.querySelectorAll('[data-vue=footer-newsletter]');
  const instances = [];

  for (const $el of elements) {
    $el.setAttribute(
      'id',
      $el.getAttribute('id') || `footer-newsletter_${instances.length}`
    );

    new Vue({
      el: $el,
      data: {
        loaded: false,
        isProcessing: false,
        email: '',
        isDone: false,
        bannersDesktop: [],
        bannersMobile: []
      },

      methods: {
        save: function (e) {
          e.preventDefault();
          const _self = this;

          _self.isProcessing = true;

          _self.$http
            .post('/rest/user/subscribe-newsletter', {
              email: this.email
            })
            .then(() => {
              this.$toast.open({
                message: 'E-mail cadastrado com sucesso!'
              });
              _self.email = '';
              _self.isDone = true;
            })
            .catch(() => {
              this.$toast.open({
                type: 'error',
                message: 'Erro ao cadastrar e-mail.'
              });
            })
            .then(() => {
              _self.isProcessing = false;
            });
        },
        async loadBanners () {
          const [desktop, mobile] = await Promise.all([
            getBannerById(30, { limit: 1 }),
            getBannerById(31, { limit: 1 })
          ]);

          this.bannersDesktop = desktop;
          this.bannersMobile = mobile;
        }
      },
      created: function () {
        this.loaded = true;
        this.loadBanners();
      }
    });
  }
})();
